/**
 * Custom HTTP Error class for consistent error handling
 */
export class HttpError extends Error {
    constructor(status, message, details = null) {
        super(message);
        this.name = 'HttpError';
        this.status = status;
        this.details = details;
        this.timestamp = new Date().toISOString();
        this.isHttpError = true;
    }

    toString() {
        return `HTTP ${this.status}: ${this.message}`;
    }

    toJSON() {
        return {
            name: this.name,
            status: this.status,
            message: this.message,
            details: this.details,
            timestamp: this.timestamp,
        };
    }

    static fromResponse(response, details = null) {
        const status = response.status;
        const message = `HTTP ${status}: ${response.statusText}`;
        return new HttpError(status, message, details);
    }

    static networkError(message = 'Network error') {
        return new HttpError(0, message);
    }

    static timeoutError(message = 'Request timeout') {
        return new HttpError(408, message);
    }
}